var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"numberValidateForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"年龄","prop":"age","rules":[
      { type: 'number', message: '年龄必须为数字值'}
    ]}},[_c('el-input',{attrs:{"type":"age","autocomplete":"off"},model:{value:(_vm.form.age),callback:function ($$v) {_vm.$set(_vm.form, "age", _vm._n($$v))},expression:"form.age"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a90158","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/B.vue
// module id = null
// module chunks = 